<template>
  <div class="lp-datepicker" v-if="$store.state.apiLoaded">
    <div v-if="$store.state.prices.length">
      <h3 class="titre d-flex">
        <i class="fal text-primary fa-calendar fa-fw"></i>
        <span class="pl-3">Quand souhaitez-vous partir ?</span>
      </h3>

      <div class="switch-wrapper mt-3">
        <button
          class="btn-calendar-months btn mr-2"
          :class="{ active: viewMonth }"
          @click="viewMonth = true"
        >
          <img :src="$store.state.pictos.calendarMonth" alt="" />
        </button>
        <button
          class="btn-calendar-days btn"
          :class="{ active: !viewMonth }"
          @click="viewMonth = false"
        ></button>
      </div>

      <div class="calendar-wrapper mt-3">
        <div v-if="viewMonth" class="calendar-months">
          <div class="nav-calendar d-flex">
            <button
              class="year-prev btn"
              @click="$store.dispatch('prevYear')"
              :disabled="$store.state.activeYearIndex - 1 < 0"
            >
              <i class="fas fa-chevron-left"></i>
            </button>
            <div class="currentYear flex-fill text-center">
              {{ activeYear }}
            </div>
            <button
              class="year-next btn"
              @click="$store.dispatch('nextYear')"
              :disabled="
                $store.state.activeYearIndex >=
                  $store.getters.availableYears.length - 1
              "
            >
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>

          <div class="main-calendar d-flex bg-white">
            <bouton-mois
              v-for="index in 12"
              :key="'mois-' + index"
              :indexMois="index - 1"
            />
          </div>

          <p class="small text-secondary legende mt-3">
            Mois avec les meilleurs prix
            <span class="text-dark ml-4">Prix par personne</span>
          </p>
        </div>

        <div v-else class="calendar-days">
          <div class="nav-calendar d-flex">
            <button
              class="year-prev btn"
              @click="$store.dispatch('prevMonth')"
              :disabled="$store.state.activeMonthIndex - 1 < 0"
            >
              <i class="fas fa-chevron-left"></i>
            </button>

            <div class="currentYear flex-fill text-center">
              {{ activeMonth }}
            </div>

            <button
              class="year-next btn"
              @click="$store.dispatch('nextMonth')"
              :disabled="
                $store.state.activeMonthIndex >=
                  $store.getters.availableMonths.length - 1
              "
            >
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>

          <div class="main-calendar d-flex bg-white">
            <div
              class="nom-jours col-jour"
              v-for="(jour, index) in $store.state.daysList"
              :key="'jour-' + index"
            >
              {{ jour }}
            </div>

            <bouton-jour
              class="col-jour"
              v-for="(jour, index) in currentMonthArray"
              :key="'realJour-' + index"
              :indexJour="jour"
            />
          </div>

          <p class="small text-secondary legende mt-3">
            Meilleur tarif du mois
            <span class="text-dark ml-4">Prix par personne</span>
          </p>
        </div>
      </div>

      <a
        :class="{ disabled: !isFormulaireValide }"
        @click="sendGTM()"
        :href="$store.getters.getURLP2"
        class="btn btn-secondary mt-4"
        >Suivant</a
      >
    </div>

    <div v-else>
      <div class="alert alert-light">
        <p class="text-center mb-0">
          Désolé, aucun voyage ne correspond à vos critères
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import BoutonMois from "./BoutonMois.vue";
import BoutonJour from "./BoutonJour.vue";

export default {
  name: "DatePicker",
  components: {
    BoutonMois,
    BoutonJour,
  },
  computed: {
    pictos() {
      return this.$store.state.pictos;
    },
    prices() {
      return this.$store.state.prices;
    },
    viewMonth: {
      get() {
        return this.$store.state.viewMonth;
      },
      set(value) {
        this.$store.dispatch("updateViewMonth", value);
      },
    },
    activeYear() {
      return this.$store.getters.activeYear;
    },
    activeMonth() {
      let activeMonth = this.$store.getters.activeMonth;

      return (
        this.$store.state.monthsList[activeMonth.month] + " " + activeMonth.year
      );
    },
    currentMonthArray() {
      const activeMonth = this.$store.getters.activeMonth;

      if (activeMonth) {
        let dd = (activeMonth.month + 1).toString().padStart(2, "0");

        let firstDay = moment(activeMonth.year + "-" + dd + "-" + "01");

        const emptyDays = (firstDay.day() + 6) % 7;

        const numberOfDays = firstDay.daysInMonth();

        let currentMonthArray = [];

        for (let i = 0; i < emptyDays; i++) {
          currentMonthArray.push(0);
        }

        for (let j = 1; j <= numberOfDays; j++) {
          currentMonthArray.push(j);
        }

        return currentMonthArray;
      }

      return [];
    },
    isFormulaireValide() {
      const nmbAdultes = this.$store.state.chambres.reduce(
        (acc, chambre) => acc + chambre.adulte,
        0
      );
      return this.$store.state.dayReservation && nmbAdultes > 0;
    },
  },

  methods: {
    sendGTM() {
      if (this.$store.state.dayReservation) {
        const args = window.funnel_data.gtm;

        args.price = this.$store.state.priceReservation;
        args.item_trip_duration = this.$store.state.selectedDuree;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "booking_date",
          ecommerce: {
            currency: "EUR",
            value: args.price,
            items: [args],
          },
        });
      }
    },
  },

  mounted() {},
};
</script>
